import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { observer, inject } from 'mobx-react';
// import socketIOClient from "socket.io-client";

// import config from "../../config";
import CardView from '../../components/Card/CardView';
import PatientInfo from '../../components/Profile/PatientInfo';
import Summary from './components/Tab/summary';
import Event from './components/Tab/event';
import Sleep from './components/Tab/sleep';
import VitalsignDetails from './components/Tab/vitalsign';
import GarminWatch from './components/Tab/garminWatch';
import Navbar from './components/Navbar/Navbar';
import moment from 'moment';
import config from '../../config';

class SummaryReportPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: 0,
      date: new Date().toDateString(),
      startDate: new Date(),
      zoomActivity: 0,
      zoomLocation: 0,
      zoomBattery: 0,
      zoomDevice: 0,
      zoomVitalsign: 0,
      action: {
        changed: {
          a: null,
          f: null,
          b: null,
          m: null,
        },
      },
      toggle: false,
      isSetting: false,
      isInfo: false,
      value: '',
      viewType: 'week',
      displayViewType: 'daily',
      isShowMinMax: true,
      lyingOnBack: true,
      lyingOnStomach: true,
      lyingOnLeft: true,
      lyingOnRight: true,
      lying: true,
      sitting: true,
      standing: true,
      walking: true,
      tooltip: {
        display: 'none',
        name: null,
        layerX: 0,
        layerY: 0,
        amount: 0,
      },
      settingPosition: {
        x: 0,
        y: 0,
      },
      data: null,
      heartrate: false,
      respiration: false,
      spo2: false,
      vitalsigns: [],
    };
  }

  async componentDidMount() {
    const result = await this.props.patient.getPatientIdByUserId(localStorage.getItem('user_id'));
    const patientId = result.map((item) => {
      return item.patientId;
    });
    if (patientId) {
      localStorage.setItem('patient_id', patientId);
    }
    this.initData(result);
  }

  initData = async (patient) => {
    (patient || []).map((val) => this.setState({ data: val }));

    let queryOption = {
      activity: true,
      energy: true,
    };
    this.props.summary.resetSummary(true);
    await this.props.summary.getGraphAvailableDate(+localStorage.getItem('patient_id'));
    this.props.summary.getVitalSignDate(+localStorage.getItem('patient_id'));
    this.props.summary.getAssignedDeviceDate(+localStorage.getItem('patient_id'));

    config.features.report.garmin && this.props.summary.getGarminDate(+localStorage.getItem('patient_id'));
    this.props.summary.getSummary(+localStorage.getItem('patient_id'), new Date(), queryOption);
    this.props.summary.getSummaryReport(+localStorage.getItem('patient_id'), new Date());
    this.props.summary.getSummaryReportAsPeriod(+localStorage.getItem('patient_id'), new Date(), 'week', [
      'sleep',
      'event',
    ]);

    const { since } = this.props.vitalsign.toJS();

    const queryLastVitalsign = {
      heartrate: true,
      temperature: true,
      bloodPressure: true,
      spo2: true,
      respirationRate: true,
    };

    const querySummaryVitalsign = {
      heartrate: true,
      temperature: true,
      bloodPressure: true,
      spo2: true,
      respirationRate: true,
      since,
    };
    this.props.vitalsign.getLastVitalSign(+localStorage.getItem('patient_id'), new Date(), queryLastVitalsign);

    this.props.vitalsign.getSummaryVitalSign(+localStorage.getItem('patient_id'), new Date(), querySummaryVitalsign);
  };

  // async subscribeToServer() {
  //   const socket = socketIOClient(`${config.api.url}`);
  //   if (localStorage.getItem("select_module")) {
  //     const selectModule = JSON.parse(localStorage.getItem("select_module"));
  //     (selectModule || []).forEach((val) => {
  //       socket.on(`module_alert_${val}`, async (payload) => {
  //         // console.log('payload alert ---> ',payload);
  //         await this.setPayload(payload);
  //       });
  //       socket.on(`module_action_${val}`, async (payload) => {
  //         // console.log('payload action ---> ',payload);
  //         await this.setPayload(payload);
  //       });
  //     });
  //   }
  // }

  // async setPayload(payload) {
  //   const { data } = this.props;
  //   if (payload.length > 0) {
  //     if (config.groupNotification) {
  //       (payload || []).map((payload) => {
  //         payload.data.changed = JSON.parse(payload.data.changed);
  //         if (
  //           data.patient &&
  //           data.patient.devices.length > 0 &&
  //           data.patient.devices[0].serial === payload.data.deviceSerial
  //         ) {
  //           this.setState({
  //             action: payload.data,
  //           });
  //         }
  //         return payload;
  //       });
  //     }
  //   }
  // }

  handleChange = (event) => {
    let tab = +event.target.getAttribute('set-key');
    this.setState({
      tab,
      zoom: 0,
      zoomActivity: 0,
      zoomLocation: 0,
      zoomVitalsign: 0,
    });
    if (tab === 7) {
      const startDate = this.getPrevDate(this.state.viewType, this.state.date);
      this.setState({ startDate });
    } else if (tab === 8) {
      const startDate = this.getPrevDate(this.state.displayViewType, this.state.date);
      this.setState({ startDate });
    }
  };

  goBack = () => {
    this.props.history.goBack();
  };

  onDateChange = async (value) => {
    const { data } = this.state;

    // donot reload data if user select same date
    const newDate = value.toDateString();
    if (this.state.date === newDate) {
      return;
    }

    let queryOption = {};
    if (localStorage.getItem('role_id') === '1') {
      queryOption = {
        activity: true,
        movement: true,
        alert: true,
        location: true,
        battery: true,
        admin: true,
        // device: true,
      };
    }
    if (localStorage.getItem('role_id') !== '1') {
      queryOption = {
        activity: true,
        movement: true,
        location: true,
      };
    }

    const queryVitalsign = {
      heartrate: true,
      temperature: true,
      bloodPressure: true,
      spo2: true,
    };

    const { since } = this.props.vitalsign.toJS();
    const querySummaryVitalsign = {
      heartrate: true,
      temperature: true,
      bloodPressure: true,
      spo2: true,
      respirationRate: true,
      since,
    };

    this.setState({
      date: value.toDateString(),
      // zoomActivity: 0,
      // zoomLocation: 0,
    });
    this.props.summary.resetSummary(false);
    this.props.summary.getSummary(data.patientId, value, queryOption);
    this.props.summary.getSummaryReport(data.patientId, value);
    this.props.summary.getSummaryReportAsPeriod(data.patientId, value, this.state.viewType, ['sleep', 'event']);

    this.props.vitalsign.getLastVitalSign(data.patientId, value, queryVitalsign);

    this.props.vitalsign.getSummaryVitalSign(data.patientId, value, querySummaryVitalsign);

    config.features.report.garmin &&
      this.props.smartwatchsummary.summaryVitalSigns(data.patientId, value, this.state.displayViewType, [
        'heartrate',
        'spo2',
        'respiration',
      ]);

    // reset zoom
    this.resetZoomVitalsign();
  };

  onChangePeriod = (viewType) => {
    const { data } = this.state;
    this.setState({ viewType });
    this.props.summary.getSummaryReportAsPeriod(data.patient.id, new Date(this.state.date), viewType, [
      'sleep',
      'event',
    ]);
  };

  onSelect = (e) => {
    let { value } = e.target;
    if (value === 'lyingOnBack') {
      this.setState({
        lyingOnBack: !this.state.lyingOnBack,
      });
    }
    if (value === 'lyingOnStomach') {
      this.setState({
        lyingOnStomach: !this.state.lyingOnStomach,
      });
    }
    if (value === 'lyingOnLeft') {
      this.setState({
        lyingOnLeft: !this.state.lyingOnLeft,
      });
    }
    if (value === 'lyingOnRight') {
      this.setState({
        lyingOnRight: !this.state.lyingOnRight,
      });
    }
    if (value === 'lying') {
      this.setState({
        lying: !this.state.lying,
      });
    }
    if (value === 'sitting') {
      this.setState({
        sitting: !this.state.sitting,
      });
    }
    if (value === 'standing') {
      this.setState({
        standing: !this.state.standing,
      });
    }
    if (value === 'walking') {
      this.setState({
        walking: !this.state.walking,
      });
    }
  };

  getAlertInfo = (value) => {
    const { t } = this.props;
    let result = `${t('unknown')}`;
    switch (value) {
      case 1:
        result = `${t('lying')}`;
        break;
      case 2:
        result = `${t('sitting')}`;
        break;
      case 3:
        result = `${t('standing')}`;
        break;
      case 4:
        result = `${t('walking')}`;
        break;
      case 5:
        result = `${t('Running')}`;
        break;
      case 6:
        result = `${t('Jumping')}`;
        break;
      case 7:
        result = `${t('lying_on_back')}`;
        break;
      case 8:
        result = `${t('lying_on_stomach')}`;
        break;
      case 9:
        result = `${t('lying_on_left_side')}`;
        break;
      case 10:
        result = `${t('lying_on_right_side')}`;
        break;
      case 501:
        result = `${t('get_up')}`;
        break;
      case 502:
        result = `${t('movement')}`;
        break;
      case 503:
        result = `${t('low_battery')}`;
        break;
      case 504:
        result = `${t('alert_last_seen')}`;
        break;
      case 505:
        result = `${t('alert_router_no_signal')}`;
        break;
      case 506:
        result = `${t('alert_not_turn')}`;
        break;
      case 507:
        result = `${t('alert_no_movement')}`;
        break;
      case 508:
        result = `${t('alert_fall')}`;
        break;
      case 509:
        result = `${t('out_of_area')}`;
        break;
      case 510:
        result = `${t('in_to_area')}`;
        break;
      case 511:
        result = `${t('alert_walking')}`;
        break;
      case 512:
        result = `${t('alert_deactivate_recharge')}`;
        break;
      case 513:
        result = `${t('alert_bad_signal')}`;
        break;
      case 514:
        result = `${t('alert_emergency_alarm')}`;
        break;
      default:
        break;
    }
    return result;
  };

  handleSetting = (e) => {
    const x = e.nativeEvent.offsetX;
    const y = e.nativeEvent.offsetY;
    // console.log(x, y);
    this.setState({
      isSetting: !this.state.isSetting,
      settingPosition: {
        ...this.state.settingPosition,
        x: x,
        y: y,
      },
    });
  };

  onMouseover = (layerX, layerY, value) => {
    this.setState({
      tooltip: {
        layerX,
        layerY,
        name: value.name,
        amount: value.amount,
        display: 'block',
      },
    });
  };
  onMouseout = () => {
    this.setState({
      tooltip: {
        layerX: 0,
        layerY: 0,
        name: null,
        amount: 0,
        display: 'none',
      },
    });
  };

  dataChartHRVsTemp(chart) {
    this.internalDataHRVsTemp = chart;
  }

  dataChartSpo2(chart) {
    this.internalDataSpo2 = chart;
  }

  dataChartBloodPressure(chart) {
    this.internalDataBloodPressure = chart;
  }

  syncZoomVitalsign = (event, task) => {
    const extremesObject = event.xAxis[0];
    switch (task) {
      case 'HRVsTemp':
        this.setState({ zoomVitalsign: 1 });
        if (this.internalDataSpo2) {
          this.internalDataSpo2.series[0].xAxis.setExtremes(extremesObject.min, extremesObject.max);
        }
        if (this.internalDataBloodPressure) {
          this.internalDataBloodPressure.series[0].xAxis.setExtremes(extremesObject.min, extremesObject.max);
        }
        break;
      case 'spo2':
        this.setState({ zoomVitalsign: 1 });
        if (this.internalDataHRVsTemp) {
          this.internalDataHRVsTemp.series[0].xAxis.setExtremes(extremesObject.min, extremesObject.max);
        }
        if (this.internalDataBloodPressure) {
          this.internalDataBloodPressure.series[0].xAxis.setExtremes(extremesObject.min, extremesObject.max);
        }
        break;
      case 'bloodpressure':
        this.setState({ zoomVitalsign: 1 });
        if (this.internalDataHRVsTemp) {
          this.internalDataHRVsTemp.series[0].xAxis.setExtremes(extremesObject.min, extremesObject.max);
        }
        if (this.internalDataSpo2) {
          this.internalDataSpo2.series[0].xAxis.setExtremes(extremesObject.min, extremesObject.max);
        }
        break;
      default:
        break;
    }
  };

  resetZoomVitalsign = async (event) => {
    this.setState({ zoomVitalsign: 0 });
    this.internalDataHRVsTemp &&
      Object.keys(this.internalDataHRVsTemp).length > 0 &&
      (await this.internalDataHRVsTemp.zoomOut());
    this.internalDataSpo2 && Object.keys(this.internalDataSpo2).length > 0 && (await this.internalDataSpo2.zoomOut());
    this.internalDataBloodPressure &&
      Object.keys(this.internalDataBloodPressure).length > 0 &&
      (await this.internalDataBloodPressure.zoomOut());
  };

  onChangeVitalsignPeriod = (viewType) => {
    const { data } = this.state;
    const startDate = this.getPrevDate(viewType, this.state.date);
    this.setState({ viewType, startDate });

    if (viewType === 'month') {
      this.props.vitalsign.setSinceData(30);
    } else if (viewType === 'year') {
      this.props.vitalsign.setSinceData(365);
    } else {
      this.props.vitalsign.setSinceData(7);
    }
    const { since } = this.props.vitalsign.toJS();
    const querySummaryVitalsign = {
      heartrate: true,
      temperature: true,
      bloodPressure: true,
      spo2: true,
      respirationRate: true,
      since,
    };
    this.props.vitalsign.getSummaryVitalSign(data.patient.id, new Date(this.state.date), querySummaryVitalsign);
  };

  onChangeGarminWatchPeriod = async (displayViewType) => {
    const { data } = this.state;
    const startDate = this.getPrevDate(displayViewType, this.state.date);
    this.setState({ displayViewType, startDate });
    const date = new Date(this.state.date);
    config.features.report.garmin &&
      this.props.smartwatchsummary.summaryVitalSigns(data.patient.id, date, displayViewType, [
        'heartrate',
        'spo2',
        'respiration',
      ]);
  };

  handleChangeVitalsign = (value) => (event) => {
    let vitalsigns = this.state.vitalsigns;
    const checked = vitalsigns.find((data) => data === value);
    if (checked) {
      vitalsigns = vitalsigns.filter((data) => data !== value);
    } else {
      vitalsigns.push(value);
    }
    this.setState({
      [value]: event.target.checked,
      vitalsigns,
    });
  };

  handleShowMinMaxValue = () => {
    this.setState({ isShowMinMax: !this.state.isShowMinMax });
  };

  handleBackButtonClick = (as) => {
    const startDate = this.getPrevDate(as, this.state.startDate);
    const endDate = this.getPrevDate(as, this.state.date);
    this.setState({
      startDate,
      date: endDate,
    });
    this.onDateChange(endDate);
  };

  handleNextButtonClick = (as) => {
    const startDate = this.getNextDate(as, this.state.startDate);
    const endDate = this.getNextDate(as, this.state.date);
    this.setState({
      startDate,
      date: endDate,
    });
    this.onDateChange(endDate);
  };

  getPrevDate(as, date) {
    let dateStart = null;
    switch (as) {
      case 'week':
        dateStart = moment(new Date(`${date}`))
          .subtract(1, 'w')
          .add(1, 'd')
          .startOf('day')
          .toDate();
        break;
      case 'month':
        dateStart = moment(new Date(`${date}`))
          .subtract(4, 'w')
          .add(1, 'd')
          .startOf('day')
          .toDate();
        break;
      case 'year':
        dateStart = moment(new Date(`${date}`))
          .subtract(1, 'y')
          .add(1, 'day')
          .startOf('day')
          .toDate();
        break;
      case 'weekly':
        dateStart = moment(new Date(`${date}`))
          .subtract(1, 'w')
          .add(1, 'd')
          .startOf('day')
          .toDate();
        break;
      case 'monthly':
        dateStart = moment(new Date(`${date}`))
          .subtract(4, 'w')
          .add(1, 'd')
          .startOf('day')
          .toDate();
        break;
      case 'yearly':
        dateStart = moment(new Date(`${date}`))
          .subtract(1, 'y')
          .add(1, 'day')
          .startOf('day')
          .toDate();
        break;
      case 'daily':
      default:
        dateStart = moment(new Date(`${date}`))
          .subtract(1, 'd')
          .startOf('day')
          .toDate();
        break;
    }

    return dateStart;
  }

  getNextDate(as, date) {
    let dateStart = null;
    switch (as) {
      case 'week':
        dateStart = moment(new Date(`${date}`))
          .add(1, 'w')
          .subtract(1, 'd')
          .startOf('day')
          .toDate();
        break;
      case 'month':
        dateStart = moment(new Date(`${date}`))
          .add(4, 'w')
          .subtract(1, 'd')
          .startOf('day')
          .toDate();
        break;
      case 'year':
        dateStart = moment(new Date(`${date}`))
          .add(1, 'y')
          .subtract(1, 'day')
          .startOf('day')
          .toDate();
        break;
      case 'weekly':
        dateStart = moment(new Date(`${date}`))
          .add(1, 'w')
          .subtract(1, 'd')
          .startOf('day')
          .toDate();
        break;
      case 'monthly':
        dateStart = moment(new Date(`${date}`))
          .add(4, 'w')
          .subtract(1, 'd')
          .startOf('day')
          .toDate();
        break;
      case 'yearly':
        dateStart = moment(new Date(`${date}`))
          .add(1, 'y')
          .subtract(1, 'day')
          .startOf('day')
          .toDate();
        break;
      case 'daily':
      default:
        dateStart = moment(new Date(`${date}`))
          .add(1, 'd')
          .startOf('day')
          .toDate();
        break;
    }
    return dateStart;
  }

  onOpenedInfo = () => {
    this.setState({
      isInfo: !this.state.isInfo,
    });
  };

  onAcknowledge = (alert, clearAlert = false) => {
    const { data } = this.state;
    const alerts = [];
    alerts.push({
      alertId: alert.alertId,
      alertType: alert.alertType,
    });
    this.props.dashboard.ackAlert(data, alerts);
    if (clearAlert) {
      this.setState({
        isAlert: false,
      });
    }
  };

  render() {
    const {
      tab,
      action,
      isSetting,
      viewType,
      lyingOnBack,
      lyingOnStomach,
      lyingOnRight,
      lyingOnLeft,
      lying,
      walking,
      standing,
      sitting,
      tooltip,
      settingPosition,
      data,
      zoomVitalsign,
      isInfo,
    } = this.state;
    let { t } = this.props;
    let {
      date,
      loadingAvailableDate,
      highlightDate,
      includeDate,
      summarySleepPeriod,
      summaryEventPeriod,
      assignedDevicesDate,
      dateMotionTracker,
      dateSOS,
      dateBeaconTag,
      dateVitalSigns,
    } = this.props.summary.toJS();
    let note = this.props.patient.toJS();
    const { routers } = this.props.router.toJS();
    const role = localStorage.getItem('role');
    const today = moment().startOf('d').format('YYYY-MM-DD');
    const dateRef = moment(new Date(date)).format('YYYY-MM-DD');
    const assignDevice = assignedDevicesDate.find((val) => {
      const dateFind = moment(new Date(val.date)).format('YYYY-MM-DD');
      return dateFind === dateRef;
    });

    const hasActivity = assignDevice && assignDevice.reportOptions && assignDevice.reportOptions.hasActivity;

    return (
      <div className='bg-primary-gradient'>
        {data && (
          <CardView>
            <div className='block w-full px-10 pt-10 xl:pt-4 lg:pt-4 md:pt-12 xl:px-20 lg:px-20 md:px-12'>
              <PatientInfo
                t={t}
                patient={data && data.patient}
                // alertInfo={this.getAlertInfo(
                //   data && data.alert && data.alert.alertType
                // )}
                alert={data && data.alert}
                device={data && data.device}
                handleSetting={this.handleSetting}
                isSetting={isSetting}
                settingPosition={settingPosition}
                date={date}
                highlightDate={highlightDate}
                includeDate={includeDate}
                loadingAvailableDate={loadingAvailableDate}
                onDateChange={this.onDateChange}
                dateMotionTracker={dateMotionTracker}
                dateSOS={dateSOS}
                dateBeaconTag={dateBeaconTag}
                dateVitalSigns={dateVitalSigns}
                today={today}
                hasActivity={hasActivity}
                isInfo={isInfo}
                openedInfo={this.onOpenedInfo}
                onAcknowledge={this.onAcknowledge}
              />
              <div className='flex pt-4'>
                <Navbar t={t} tab={tab} handleChange={this.handleChange} role={role} />
              </div>
            </div>
          </CardView>
        )}

        <div className='w-screen bg-transparent'>
          {tab === 0 && (
            <Summary
              t={t}
              action={action}
              devices={data && data.patient.devices}
              patient={data && data.patient}
              data={this.props.summary.toJS()}
              vitalsign={this.props.vitalsign.toJS()}
              note={note}
              routers={routers}
              alertType={data && data.alert && data.alert.alertType}
              role={role}
              hasActivity={hasActivity}
            />
          )}
          {tab === 1 && (
            <Event
              t={t}
              data={summaryEventPeriod}
              date={date}
              onChangePeriod={this.onChangePeriod}
              viewType={viewType}
              onSelect={this.onSelect}
              display={{ total: false, lying, walking, standing, sitting }}
              onMouseover={this.onMouseover}
              onMouseout={this.onMouseout}
              tooltip={tooltip}
              hasActivity={hasActivity}
            />
          )}
          {tab === 2 && (
            <Sleep
              t={t}
              data={summarySleepPeriod}
              date={date}
              onChangePeriod={this.onChangePeriod}
              viewType={viewType}
              onSelect={this.onSelect}
              display={{
                lyingTotal: false,
                lyingOnBack,
                lyingOnStomach,
                lyingOnLeft,
                lyingOnRight,
              }}
              onMouseover={this.onMouseover}
              onMouseout={this.onMouseout}
              tooltip={tooltip}
              hasActivity={hasActivity}
            />
          )}
          {tab === 7 && (
            <VitalsignDetails
              zoom={Boolean(zoomVitalsign)}
              syncZoom={this.syncZoomVitalsign}
              resetZoom={this.resetZoomVitalsign}
              dataChartHRVsTemp={this.dataChartHRVsTemp}
              dataChartSpo2={this.dataChartSpo2}
              dataChartBloodPressure={this.dataChartBloodPressure}
              onChangePeriod={this.onChangeVitalsignPeriod}
              viewType={viewType}
              endDate={this.state.date}
              startDate={this.state.startDate}
              handleBackButtonClick={this.handleBackButtonClick}
              handleNextButtonClick={this.handleNextButtonClick}
            />
          )}
          {tab === 8 && config.features.report.garmin && (
            <GarminWatch
              viewType={this.state.displayViewType}
              isShowMinMax={this.state.isShowMinMax}
              heartrate={this.state.heartrate}
              respiration={this.state.respiration}
              spo2={this.state.spo2}
              vitalsigns={this.state.vitalsigns}
              endDate={this.state.date}
              startDate={this.state.startDate}
              onChangePeriod={this.onChangeGarminWatchPeriod}
              handleChange={this.handleShowMinMaxValue}
              handleChangeVitalsign={this.handleChangeVitalsign}
              handleBackButtonClick={this.handleBackButtonClick}
              handleNextButtonClick={this.handleNextButtonClick}
            />
          )}
        </div>
      </div>
    );
  }
}

export const page = inject(
  'summary',
  'bed',
  'patient',
  'dashboard',
  'router',
  'vitalsign',
  'smartwatchsummary',
)(observer(SummaryReportPage));
export const translation = withTranslation()(page);
export default translation;
